$(document).ready(function () {
  setTimeout(function () {
    $("#banner-slider").owlCarousel({
      margin: 0,
      loop: true,
      slideSpeed: 7000,
      paginationSpeed: 400,
      autoplay: true,
      nav: false,
      pagination: false,
      dots: false,
      navText: [
        "<img src='https://cdn.shopify.com/s/files/1/0879/6776/0691/files/Group_515783.svg?v=1715765252'>",
        "<img src='https://cdn.shopify.com/s/files/1/0879/6776/0691/files/Group_515781.svg?v=1715765253'>",
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        700: {
          items: 1,
        },
        1000: {
          items: 1,
        },
        1100: {
          items: 1,
        }
      }
    });
    
  }, 500);
   $('.feature-slider').slick({
  dots: false,
    arrow:true,
    infinite: true,
    autoplay: true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  // In-stock-first collection loader.
  // Phase 1 streams Shopify's availability filter (in-stock only) page by page.
  // Phase 2 streams the unfiltered collection and appends only products not shown yet, i.e. the sold-out ones.
  // If the availability filter is not enabled in Search & Discovery, behaviour is the original "View More" loader.
  (function () {
    var $grid = $("#product-grid");
    if (!$grid.length) return;
    var $btn = $(".load-more-btn"), $spin = $(".load-more-spinner"), $wrap = $(".viewmore-btn");
    var sectionId = $grid.attr("data-id"), collectionUrl = $grid.attr("data-collection-url");
    var params = new URLSearchParams(window.location.search);
    var filterEnabled = $grid.attr("data-availability-filter-enabled") === "true";
    var userChoseAvailability = params.has("filter.v.availability") || $grid.attr("data-availability-filter-active") === "true";
    var enabled = $grid.attr("data-instock-first") === "true" && filterEnabled && collectionUrl && sectionId && !userChoseAvailability && !params.has("page");

    function keyOf(li) {
      var a = li.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute("href").match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }
    function legacy() {
      var nextUrl = $grid.attr("data-next-url");
      if (nextUrl) { $btn.show(); $wrap.show(); }
      $btn.off("click.isf").on("click.isf", function (e) {
        e.preventDefault(); if (!nextUrl) return;
        $btn.hide(); $spin.show();
        $.get(nextUrl, function (nextPage) {
          $spin.hide();
          var $new = $(nextPage).find("#product-grid");
          $grid.append($new.html());
          nextUrl = $new.attr("data-next-url");
          if (nextUrl) $btn.show();
        }, "html");
      });
    }
    if (!enabled) { legacy(); return; }

    var seen = {};
    function buildUrl(avail, page) {
      var p = new URLSearchParams(window.location.search);
      if (avail) p.set("filter.v.availability", avail); else p.delete("filter.v.availability");
      p.set("page", page); p.set("section_id", sectionId);
      return collectionUrl + "?" + p.toString();
    }
    function parse(html) {
      var doc = document.implementation.createHTMLDocument("");
      doc.body.innerHTML = html;
      var grid = doc.querySelector("#product-grid");
      return grid ? { items: Array.prototype.slice.call(grid.querySelectorAll("li.grid__item")), next: grid.getAttribute("data-next-url") || null } : null;
    }
    function appendNew(items) {
      var added = 0;
      items.forEach(function (li) { var k = keyOf(li); if (k && seen[k]) return; if (k) seen[k] = true; $grid.append(li); added++; });
      return added;
    }
    // stream "1" = in-stock pages, stream "" = all pages (dedupe leaves the sold-out ones)
    var state = { stream: "1", page: 1, done: false, busy: false };
    function finish() { state.done = true; $btn.hide(); $spin.hide(); $wrap.hide(); }
    function advance(next) {
      if (next) { state.page++; }
      else if (state.stream === "1") { state.stream = ""; state.page = 1; }
      else { finish(); return; }
      $btn.show(); $wrap.show();
    }
    function loadNext(addedSoFar) {
      if (state.done || state.busy) return;
      state.busy = true; $btn.hide(); $spin.show();
      $.get(buildUrl(state.stream, state.page), function (html) {
        state.busy = false; $spin.hide();
        var r = parse(html); if (!r) { finish(); return; }
        var added = (addedSoFar || 0) + appendNew(r.items);
        advance(r.next);
        // in the sold-out phase, keep going until this click has produced something to look at
        if (!state.done && state.stream === "" && added < 8) loadNext(added);
      }, "html").fail(function () { state.busy = false; $spin.hide(); $btn.show(); });
    }

    $grid.css("opacity", "0.35"); state.busy = true; $spin.show(); $btn.hide();
    $.get(buildUrl("1", 1), function (html) {
      state.busy = false; $spin.hide(); $grid.css("opacity", "");
      var r = parse(html); if (!r) { legacy(); return; }
      $grid.empty(); seen = {};
      var added = appendNew(r.items);
      advance(r.next);
      $btn.off("click.isf").on("click.isf", function (e) { e.preventDefault(); loadNext(0); });
      if (added === 0 && !state.done) loadNext(0);   // nothing in stock at all: go straight to the sold-out pages
    }, "html").fail(function () { state.busy = false; $grid.css("opacity", ""); legacy(); });
  })();
});
